import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function CloseX({
  size = "16",
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7949 13.4021L11.874 10.3838C11.7422 10.2476 11.5635 10.1719 11.376 10.1719H10.8984C11.707 9.10322 12.1875 7.75908 12.1875 6.29688C12.1875 2.81846 9.45996 0 6.09375 0C2.72754 0 0 2.81846 0 6.29688C0 9.77529 2.72754 12.5938 6.09375 12.5938C7.50879 12.5938 8.80957 12.0973 9.84375 11.2617V11.7552C9.84375 11.9489 9.91699 12.1336 10.0488 12.2698L12.9697 15.2881C13.2451 15.5727 13.6904 15.5727 13.9629 15.2881L14.792 14.4313C15.0674 14.1468 15.0674 13.6866 14.7949 13.4021ZM6.09375 10.1719C4.02246 10.1719 2.34375 8.44023 2.34375 6.29688C2.34375 4.15654 4.01953 2.42188 6.09375 2.42188C8.16504 2.42188 9.84375 4.15352 9.84375 6.29688C9.84375 8.43721 8.16797 10.1719 6.09375 10.1719Z"
        fill={color}
      />
    </svg>
  );
}
